<template>
    <auth-layout>
        <header-title title="Riwayat Event" />
        

        <div class="row mt-3">
            <div class="col-12 mb-5">
                <loading-block v-if="loading" />
                <div v-else>
                    <div>
                       
                        <div class="promo row" v-if="events.length > 0">
                            <div class="col-6">
                                <Eventlist 
                                    v-for="item in events.slice(0,2)"
                                    :key="item._id"
                                    :id="item._id"
                                    :image="item.file"
                                    :title="item.title"
                                    :summary="item.summary"
                                    :description="item.description"
                                    :date="item.created_at"
                                    author=""
                                    view=""
                                    :link="item.url"

                                    @Refresh="Reload"
                                />
                            </div>
                            <div class="col-6">
                                <Eventlist
                                    v-for="item in events.slice(2,4)"
                                    :key="item._id"
                                    :id="item._id"
                                    :image="item.file"
                                    :title="item.title"
                                    :summary="item.summary"
                                    :description="item.description"
                                    :date="item.created_at"
                                    author=""
                                    view=""
                                    :link="item.url"
                                     @Refresh="Reload"
                                />
                            </div>
                        </div>
                        <div v-else class="text-center">
                            <p>Tidak ada Riwayat Event </p>
                        </div>
                    </div>

                    <div class="button-wrap" v-if="events.length > 0">
                    <div class="row">
                        <div class="col-6">
                            <button class="btn  pointer btn-primary main-button pill-button" @click="prevPage" :disabled="btndisable">Sebelumnya</button>
                        </div>
                        <div class="col-6">
                            <button class="btn pointer btn-primary main-button pill-button bg-orange" @click="nextPage">Selanjutnya</button>
                        </div>
                    </div>
                </div>


                </div>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import axios from "axios";
import Eventlist from "../../mobile/components/Card/Eventlist";
export default {
    data() {
        return {
            events: [],
            loading: true,
            current_page: 1,
            total_page: 1,
            btndisable:true,
        }
    },
    components: {
      
        Eventlist
       
    },
    mounted() {
        this.getEvent()
    },
    methods: {
       getEvent(page = 1) {
            const token = this.$cookies.get('token');
            axios.get(`/api/event?page=${page}`, { headers: {"Authorization" : `Bearer ${token}`} })
            
                .then((response) => {
                    this.events = response.data.data;
                    this.total_page = response.data.total;
                    this.current_page = response.data.current_page;
                    this.loading = false;

                    if(this.current_page > 1)
                    {
                        this.btndisable = false;
                    }    

                    
                })
                .catch((error) => {

                });
        },
        nextPage(){
            const page = this.current_page + 1;
            this.getEvent(page)
            window.scrollTo(0,0);
        },
        prevPage() {
            const page = this.current_page - 1;
            this.getEvent(page)
            window.scrollTo(0,0);
        },
    }
}
</script>

<style>
.pointer{
    cursor: pointer;
}
.button:disabled,
.button[disabled]{
    background: #f59366;
}
.promo {
    padding: 0 5%;
}
</style>    
